import { AllowedCallTypes, CrudConfig } from "seneca-common/utils/apiStates";

export const feedbackCrudConfig: CrudConfig = Object.freeze({
  name: "feedback",
  path: "seneca/feedback/meta",
  idFieldName: "feedbackId",
  callTypes: [AllowedCallTypes.CREATE]
});
